import { useMemo } from "react";

import getProductionTeamMembers from "astrid-firestore/src/api/productions/team/getProductionTeamMembers";

export default function useProductionTeam(production) {
	return useMemo(() => getProductionTeamMembers(production), [production?.team]);
}
